<script setup lang="ts">
import { computed } from "vue";

import { useBrokers } from "@/queries/submissions";

const { data: brokers } = useBrokers();

const props = withDefaults(defineProps<{
	brokerValue?: string | undefined | null;
	disabled?: boolean;
	clearable?: boolean;
}>(), {
	brokerValue: undefined,
	disabled: false,
	clearable: false,
});

const brokerSelectOpts = computed(() => {
	return brokers.value?.map((b) => ({
		label: b.name ?? b.email,
		value: b.email,
		avatar: {
			alt: b.name ?? b.email,
			src: b.avatar ?? "",
		},
	}));
});

const emit = defineEmits<{
	(e: "update:brokerValue", value: string | undefined): void;
}>();

const selectedBroker = computed({
	get: () => brokerSelectOpts.value?.find((opt) => opt.value === props.brokerValue),
	set: (newVal) => emit("update:brokerValue", newVal?.value),
});
</script>
<template>
  <USelectMenu
    v-model="selectedBroker"
    :avatar="selectedBroker?.avatar"
    :items="brokerSelectOpts"
    :disabled="props.disabled"
    :clear="props.clearable"
    option-attribute="label"
    placeholder="Select a broker"
    class="w-full"
  />
</template>
